/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Term {
  ONBOARDING_TERMS_OF_USE_AND_PRIVACY_POLICY_OF_MEDSIMPLES_APPLICATION = 'ONBOARDING_TERMS_OF_USE_AND_PRIVACY_POLICY_OF_MEDSIMPLES_APPLICATION',
}
